import Vue from "vue";
import moment from "moment";
import {
  ValidationProvider,
  ValidationObserver,
  extend,
} from "vee-validate/dist/vee-validate.full";

// Use the provider immediately
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

extend("time", {
  getMessage: (field) => "Invalid time",
  validate: (value) => {
    if (value == null || value == "") return true;
    var patt = /(2[0-3]|[01]?[0-9]):([0-5]?[0-9])/i;
    return patt.test(value);
  },
});

extend('mindate', {
  validate: (value, { min }) => {
      return moment(value).isSameOrAfter(min);
  },
  params: ['min'],
  message: 'Invalid date'
});